export const emptyContent = () => ({ text: "", entities: [], buttons: [], media_mode: "none", upload_id: null, vault_media_id: null });
export const normalizeLink = (value) => {
  const v = value.trim();
  if (/^@[A-Za-z][A-Za-z0-9_]{3,31}$/.test(v)) return `https://t.me/${v.slice(1)}`;
  if (v.startsWith("t.me/")) return `https://${v}`;
  return v;
};
export function adjustEntities(before, after, entities) {
  let start = 0, oldEnd = before.length, newEnd = after.length;
  while (start < oldEnd && start < newEnd && before[start] === after[start]) start++;
  while (oldEnd > start && newEnd > start && before[oldEnd - 1] === after[newEnd - 1]) { oldEnd--; newEnd--; }
  const delta = newEnd - oldEnd;
  return entities.flatMap((e) => {
    if (e.offset + e.length <= start) return [e];
    if (e.offset >= oldEnd) return [{ ...e, offset: e.offset + delta }];
    // A changed formatted span is removed, never allowed to point at unrelated text.
    return [];
  });
}
export function dateInZone(zone, daysAgo = 0) {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: zone, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date());
  const get = (type) => parts.find((p) => p.type === type).value;
  const day = new Date(`${get("year")}-${get("month")}-${get("day")}T12:00:00Z`);
  day.setUTCDate(day.getUTCDate() - daysAgo);
  return day.toISOString().slice(0, 10);
}
export function originalEntities(post) {
  const names = { MessageEntityBold: "bold", MessageEntityItalic: "italic", MessageEntityUnderline: "underline", MessageEntityStrike: "strike", MessageEntitySpoiler: "spoiler", MessageEntityCode: "code", MessageEntityTextUrl: "link" };
  return (post.entities || []).filter((e) => names[e._]).map((e) => ({ type: names[e._], offset: e.offset, length: e.length, ...(e.url ? { url: e.url } : {}) }));
}
export function moveButton(rows, row, column, direction) {
  const next = rows.map((r) => r.map((b) => ({ ...b })));
  if (direction === "left" || direction === "right") {
    const other = column + (direction === "left" ? -1 : 1);
    if (other >= 0 && other < next[row].length) [next[row][column], next[row][other]] = [next[row][other], next[row][column]];
  } else {
    const target = row + (direction === "up" ? -1 : 1);
    if (target < 0 || (next[target]?.length || 0) >= 8) return rows;
    const [button] = next[row].splice(column, 1);
    if (!next[target]) next[target] = [];
    next[target].push(button);
  }
  return next.filter((r) => r.length);
}
